<h2>Expenses</h2>

<magieno-advanced-table
  [columns]="columns"
  [(searchQuery)]="searchQuery"
  [state]="tableState"
  (searchQueryChange)="this.refresh()"
>
  <tbody>
    @for (expense of searchResult.results; track expense.id) {
      <tr>
        <td>{{ expense.transactionDate | date:'shortDate' }}</td>
        <td>{{ expense.description }}</td>
        <td>{{ expense.amount / 1000 | currency:'USD': true }}</td>
        <td></td>
        <!--    <td>{{ expense.categories ? expense.categories.join(', ') : '' }}</td>-->
        <!--    <td>{{ expense.labels ? expense.labels.join(', ') : '' }}</td>-->
      </tr>
    }

  </tbody>
</magieno-advanced-table>
